export const store = {
  visible: false,
  isAdvanced: false,
  loading: false,
  data: {
    analytics: false,
    marketing: false,
    preferences: false,
    sale_of_data: true,
  },
  form: {
    analytics: false,
    marketing: false,
    preferences: false,
    sale_of_data: true,
  },
  init() {
    window.Shopify.designMode && this.customizer();

    let i = this;

    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      (error) => {
        console.log("error", error);
        if (error) {
          console.error("Failed to load the consent tracking API:", error);
          return;
        }

        const consent = window.Shopify.customerPrivacy.currentVisitorConsent();

        this.data = transformConsent(consent);
        this.form = {
          ...this.data,
        };

        this.debug();

        const userCanBeTracked =
          window.Shopify.customerPrivacy.userCanBeTracked();
        const userTrackingConsent =
          window.Shopify.customerPrivacy.getTrackingConsent();

        if (userTrackingConsent === "no_interaction") {
          setTimeout(() => {
            i.visible = true;
          }, 3000);
        }
      },
    );
  },
  debug() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent =
      window.Shopify.customerPrivacy.getTrackingConsent();
    const currentVisitorConsent =
      window.Shopify.customerPrivacy.currentVisitorConsent();
    const shouldShowBanner = window.Shopify.customerPrivacy.shouldShowBanner();

    console.log("userCanBeTracked", userCanBeTracked);
    console.log("userTrackingConsent", userTrackingConsent);
    console.log("currentVisitorConsent", currentVisitorConsent); 
    console.log("shouldShowBanner", shouldShowBanner);
  },
  customizer() {
    document.addEventListener("shopify:section:select", (event) => {
      const { sectionId } = event.detail;
      if (sectionId.includes("consent")) {
        this.visible = true;
      }
    });

    document.addEventListener("shopify:section:deselect", () => {
      this.visible = false;
    });
  },
  close() {
    this.visible = false;
    this.closeAdvanced();

    
    window.Alpine.store("popup").shouldOpen();
  },
  open() {
    this.visible = true;
  },
  openAdvanced() {
    this.visible = true;
    this.isAdvanced = true;
  },
  closeAdvanced() {
    this.isAdvanced = false;
  },
  accept() {
    this.setConsent({
      sale_of_data: true,
      analytics: true,
      marketing: true,
      preferences: true,
    }).then(() => {
      this.close();
    });
  },
  deny() {
    this.setConsent({
      sale_of_data: false,
      analytics: false,
      marketing: false,
      preferences: false,
    }).then(() => {
      this.close();
    });
  },
  saveChoices() {
    this.loading = true;

    this.setConsent({
      ...this.form,
      sale_of_data: true,
    }).then(() => {
      this.close();
    });
  },
  async setConsent(consent) {
    this.loading = true;
    try {
      await window.Shopify.customerPrivacy.setTrackingConsent(consent, (t) => {
        console.log("Consent captured", t);
        this.debug();
      });
    } catch (error) {
      console.error("Failed to set consent:", error);
    } finally {
      this.loading = false;
    }
  },
  get hasPendingChanges() {
    return Object.keys(this.form).some(
      (key) => this.form[key] !== this.data[key],
    );
  },
};

function transformConsent(consent) {
  return {
    sale_of_data: Boolean(consent.sale_of_data == "yes"),
    analytics: Boolean(consent.analytics == "yes"),
    marketing: Boolean(consent.marketing == "yes"),
    preferences: Boolean(consent.preferences == "yes"),
  };
}
